import { AlertOctagon, UsersCheck } from '@untitled-ui/icons-react/build/cjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NotFoundUI from 'src/components/NotFoundUI';

import { ROUTES } from '../../constants/routes';
import { verify } from '../../services/AuthService';
import AuthWrapper from '../AppLayout/AuthWrapper';

const Verification = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [verifyMessageTitle, setVerifyMessageTitle] = useState<string>('');
    const [verifySubMessage, setVerifySubMessage] = useState<string>('');

    useEffect(() => {
        let data = {
            code: searchParams.get('token'),
        } as any;

        if (data?.code) {
            setIsLoading(true);

            verify(data)
                .then((response) => {
                    setIsLoading(false);

                    if (response?.status === 'success' && response?.data?.code !== '') {
                        localStorage.setItem('verify_code', response?.data?.code);
                        setVerifyMessageTitle(t('Auth.Verification.Invitation_Accepted'));
                        setVerifySubMessage(t('Auth.Verification.Account_Active'));
                        setIsVerified(true);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    setVerifyMessageTitle(error?.response?.data?.isAlreadyVerified ? t('Auth.Verification.Account_Already_Verified') : t('Auth.Verification.Failed_To_Verify'));
                    setVerifySubMessage(error?.response?.data?.message || t('Auth.Verification.Something_Went_Wrong'));
                });
        } else {
            navigate(ROUTES.LOGIN);
        }
    }, []);

    const handleRedirect = () => {
        if (isVerified) {
            navigate(`${ROUTES.CREATE_PASSWORD}`);
        } else {
            navigate(ROUTES.LOGIN);
        }
    };

    return (
        <>
            <AuthWrapper>
                {isLoading ? (
                    <NotFoundUI
                        title={t('Auth.Verification.Please_Hold')}
                        desc={t('Auth.Verification.Token_Processing')}
                        iconClassName="!hidden"
                        iconSecondaryClassName={`!flex custom-loading`}
                        iconSecondary={
                            <>
                                <UsersCheck className="text-primary custom-loading" />{' '}
                            </>
                        }
                        handleActionType={() => true}
                        buttonText="Continue button"
                        contentClassName="before:!bg-none mb-[38px] !px-0 min-w-[360px]"
                        buttonType="btn_primary_black w-full btn-custom-lg"
                        containerClassName="!mx-0"
                        buttonClassName="w-full"
                        titleClassName="mb-2 !text-[16px] w-fit mx-auto custom-loading !leading-[24px] !font-semibold"
                        btnClass="mx-auto custom-loading"
                        descClass="!text-sm !p-0 mb-3 custom-loading !font-normal sm:!max-w-[360px] !text-grayLight600"
                        btnIcon={<></>}
                    />
                ) : (
                    <>
                        <NotFoundUI
                            title={verifyMessageTitle}
                            desc={verifySubMessage}
                            iconClassName="!hidden"
                            contentClassName="before:!bg-none mb-[38px] !px-0 min-w-[360px]"
                            iconSecondaryClassName={`!flex`}
                            iconSecondary={<>{isVerified ? <UsersCheck className="text-primary" /> : <AlertOctagon className="text-fgErrorPrimary" />}</>}
                            handleActionType={() => handleRedirect()}
                            buttonText={isVerified ? t('Auth.Verification.Continue') : t('Auth.Verification.Back_To_Login')}
                            buttonType="w-full btn_primary_black btn-custom-lg "
                            containerClassName="!mx-0"
                            buttonClassName="w-full"
                            btnClass="w-full"
                            titleClassName="mb-2 !text-[16px] !leading-[24px] !font-semibold"
                            descClass="!text-sm !p-0 mb-3 !font-normal sm:!max-w-[360px] !text-grayLight600"
                            btnIcon={<></>}
                        />
                    </>
                )}
            </AuthWrapper>
        </>
    );
};

export default Verification;
